// Vendor imports
const { connect } = require('react-redux')
// Client V2 common imports
const deferDispatch = require('client-v2/common/state/dispatch')
const routerActions = require('client-v2/common/state/router/actions')
const searchActions = require('client-v2/common/state/search/actions')
const ConnectAuthModalActions = require('client-v2/common/containers/auth-modal/actions-component')
// Container imports
const LandingHeader = require('./component-dumb')

function mapStateToProps(state) {
  return {
    ...ConnectAuthModalActions.mapStateToProps(state),
    experiment: state.user.getExperiment('*logged_out_top_cta')
  }
}

function mapDispatchToProps(dispatch) {
  const { dispatchAction } = deferDispatch(dispatch)
  return {
    ...ConnectAuthModalActions.mapDispatchToProps(dispatch),
    onSearchNavigate: dispatchAction(routerActions.navigate),
    onSearchSubmit: dispatchAction(searchActions.navigateToArticleSearch)
  }
}

module.exports = connect(
  mapStateToProps,
  mapDispatchToProps
)(
  LandingHeader
)
